const { NODE_ENV, REACT_APP_CIRCLE_BRANCH, BRANCH } = process.env

import * as Sentry from '@sentry/react'

export default {
  error
}

function error(err) {
  const isProduction = NODE_ENV === 'production'
  // Give us detailed information about the error if it's available.
  // This is particularly useful with Axios errors.
  if (isProduction && err.response) {
    return
  } else if (isProduction) {
    if (Sentry) {
      try {
        Sentry.captureException(err)
      } catch (err) {
        console.error('Unable to capture exception using Sentry:', err)
      }
    }
  }

  if (
    REACT_APP_CIRCLE_BRANCH === 'master' ||
    BRANCH === 'master' ||
    NODE_ENV === 'test'
  )
    return
  console.error(err)
}
